/**
 * Module for handling keyboard navigation
 * Fire callback on losing focus on first and last focusable elements
 */
export default function keyboardFocusCallback(
  wrapper,
  callbackForLosingForwards,
  callbackForLosingBackwards,
  elements,
) {
  // eslint-disable-next-line no-param-reassign
  elements = elements || [
    ...wrapper.querySelectorAll(
      'a[href], button, input, textarea, select, details, div[tabindex]:not([tabindex="-1"])',
    ),
  ];

  // define the same callback for both directions if not defined separately
  // eslint-disable-next-line no-param-reassign
  callbackForLosingBackwards = callbackForLosingBackwards || callbackForLosingForwards;

  function handleFocus(event) {
    if (event.key === 'Tab') {
      const firstFocusable = elements[0];
      const lastFocusable = elements[elements.length - 1];
      const isShift = !!event.shiftKey;

      if (document.activeElement === firstFocusable && isShift) {
        if (callbackForLosingBackwards) {
          callbackForLosingBackwards(event);
        }
      } else if (document.activeElement === lastFocusable && !isShift) {
        if (callbackForLosingForwards) {
          callbackForLosingForwards(event);
        }
      }
    }
  }

  wrapper.addEventListener('keydown', handleFocus);
}
